import React from 'react'
import { FormNewTags } from '../../../../../../shared/form-new/form-tags'
import { normalizeEmail } from './fields'

// The test allowlist (staff only). The section's lede explains it: while it
// has addresses, only these people are sent to this connection.
export const SectionTesting = () =>
  <div style={{ maxWidth: 560 }}>
    <FormNewTags name="testAllowlist" label="Test addresses" normalize={normalizeEmail} placeholder="Add an email address and press Enter" />
  </div>
